<div class="row align-items-center mb-2">
    <div class="col-12" [ngClass]="{'col-md-6': budgetFund?.length>1, 'col-md-9': showRightPanel}">
        <h1 class="page-header mb-0"><i class="fas fa-user-friends"></i> Empleados</h1>
    </div>

    @if(budgetFund?.length>1){
        hoola
    <div class="col-12 col-md-3 d-flex justify-content-md-end mt-2 mt-md-0">
        <div class="btn-group">
            @for(f of budgetFund; track f.id){
            <button class="btn btn-white btn-sm" [ngStyle]="{'min-width': '120px'}"
                [class.active]="fundSelect == f.fundCode" (click)="changeFund(f.fundCode)">Fondo {{f.fundCode}}</button>
            }
        </div>
    </div>
    }
    @if(budgetStatus==2 && showRightPanel){

    <div class="col-12 col-md-3 d-flex justify-content-md-end mt-2 mt-md-0">
        @if(rightTab === 'aps'){
        <button type="button" class="btn btn-outline-secondary btn-xs py-1 text-nowrap"
                        (click)="loadPendingAps(true)" [disabled]="isLoadingAps" title="Refrescar datos desde APS">
                        <i class="fas fa-sync-alt me-1" [class.fa-spin]="isLoadingAps"></i> Refrescar APS
        
        </button>
    }
     @if(rightTab === 'aasinet'){
        
    
                    <button type="button" class="btn btn-outline-primary btn-sm text-nowrap"
                        (click)="syncSubAccounts()" [disabled]="isSyncingAasinet" title="Sincronizar cuentas auxiliares desde Aasinet">
                        <i class="fas" [ngClass]="isSyncingAasinet ? 'fa-spinner fa-spin' : 'fa-cloud-download-alt'"></i>
                        <span class="ms-1">{{ isSyncingAasinet ? 'Sincronizando...' : 'Sincronizar Diversos' }}</span>
                    </button>
                }
        
    </div>
    }
</div>

<div class="row g-3">
    <!-- PANEL IZQUIERDO: EMPLEADOS ACTIVOS EN PRESUPUESTO -->
    <div class="col-12" [ngClass]="(budgetStatus==2 && showRightPanel) ? 'col-md-7' : 'col-12'">
        <div class="panel p-3">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="mb-0 text-dark">
                    <i class="fas fa-users text-success me-2"></i> Empleados Activos
                    <span class="badge bg-success ms-1">{{filteredActiveEmployees?.length || 0}}</span>
                </h5>
                @if(budgetStatus==2){
                <button type="button" class="btn btn-sm" [ngClass]="showRightPanel ? 'btn-outline-secondary' : 'btn-primary'"
                    (click)="toggleRightPanel()">
                    <i class="fas" [ngClass]="showRightPanel ? 'fa-chevron-right me-1' : 'fa-user-plus me-1'"></i>
                    {{ showRightPanel ? 'Ocultar Panel' : 'Incorporar / Sincronizar' }}
                </button>
                }
            </div>

            <!-- Filtros Panel Izquierdo -->
            <div class="row g-2 mb-3 align-items-center">
                <div class="col-12 col-md-7">
                    <div class="input-group input-group-sm">
                        <span class="input-group-text bg-light"><i class="fas fa-search text-muted"></i></span>
                        <input type="text" class="form-control" placeholder="Buscar por código, nombre o depto..."
                            [(ngModel)]="txtFindActive" (input)="filterActiveEmployees()">
                        @if(txtFindActive){
                        <button class="btn btn-outline-secondary" type="button"
                            (click)="txtFindActive=''; filterActiveEmployees()">
                            <i class="fas fa-times"></i>
                        </button>
                        }
                    </div>
                </div>
                <div class="col-12 col-md-5">
                    <select class="form-select form-select-sm" [(ngModel)]="selectedActiveTypeFilter"
                        (change)="filterActiveEmployees()">
                        <option [ngValue]="null">Todos los tipos </option>
                        @for(t of dataEmployeeType; track t.employeeType){
                        <option [value]="t.employeeType">{{t.employeeTypeName}}</option>
                        }
                    </select>
                </div>
            </div>

            <!-- Tabla Empleados Activos -->
            <div class="table-data mb-3">
                <table class="table table-hover table-sm align-middle mb-0">
                    <thead class="sticky-top">
                        <tr>
                            <th style="width: 70px;">Cód</th>
                            <th>Nombre Funcionario</th>
                            <th class="text-center" style="width: 60px;">FMR</th>
                            <th>Tipo Empleado</th>
                            @if(budgetStatus==2){
                            <th class="text-center" style="width: 80px;">Acciones</th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        @if(filteredActiveEmployees?.length === 0){
                        <tr>
                            <td colspan="5" class="text-center text-muted py-4">
                                <em>No se encontraron empleados activos con el criterio de búsqueda.</em>
                            </td>
                        </tr>
                        }
                        @for(d of filteredActiveEmployees; track d.id){
                        <tr>
                            <td><span class="fw-bold">{{d.code}}</span></td>
                            <td>
                                <div class="fw-semibold text-dark">{{d.names}}</div>
                                @if(d.departamentCode && d.departamentCode !== '-1' && d.departamentCode !== '0'){
                                <small class="text-muted d-block" style="font-size: 11px;">
                                    <i class="fas fa-building me-1 opacity-50"></i>{{d.departamentCode}} - {{d.departamentName || ''}}
                                </small>
                                }
                            </td>
                            <td class="text-center">{{ (d.type == 1 || d.type == 2) ? (d.employeeFmr || '-') : '-' }}
                            </td>
                            <td>
                                <span class="badge border" [ngClass]="{
                                    'border-primary text-primary': d.type == 1,
                                    'border-info text-info': d.type == 2,
                                    'border-secondary text-secondary': d.type == 3
                                }">
                                    {{d.employeeTypeName}}
                                </span>
                            </td>
                            @if(budgetStatus==2){
                            <td class="text-center">
                                <div class="d-flex justify-content-center gap-1">
                                    <button type="button" class="btn btn-outline-primary btn-xs"
                                        ngbTooltip="Editar datos" container="body" (click)="setFormDiverse(d)">
                                        <i class="fa fa-pencil-alt"></i>
                                    </button>
                                    <button type="button" class="btn btn-outline-warning btn-xs"
                                        ngbTooltip="Excluir del presupuesto" container="body"
                                        (click)="excludeEmployee(d)">
                                        <i class="fa fa-user-slash"></i>
                                    </button>
                                </div>
                            </td>
                            }
                        </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <!-- PANEL DERECHO: BANDEJA DE DISPONIBLES (NUEVOS APS, AASINET, INACTIVOS) -->
    @if(budgetStatus==2 && showRightPanel){
    <div class="col-12 col-md-5">
        <div class="panel p-3">
            <!-- Header con pestañas y botón de cerrar -->
            <div class="d-flex justify-content-between align-items-center mb-3">
                <div class="btn-group w-100 me-2" role="group">
                    <button type="button" class="btn btn-sm"
                        [ngClass]="rightTab === 'aps' ? 'btn-primary' : 'btn-outline-secondary'" (click)="rightTab = 'aps'">
                        <i class="fas fa-sync-alt me-1"></i> APS
                        <span class="badge ms-1"
                            [ngClass]="rightTab === 'aps' ? 'bg-white text-primary' : 'bg-secondary text-white'">
                            {{pendingApsEmployees?.length || 0}}
                        </span>
                    </button>
                    <button type="button" class="btn btn-sm"
                        [ngClass]="rightTab === 'aasinet' ? 'btn-primary' : 'btn-outline-secondary'" (click)="rightTab = 'aasinet'">
                        <i class="fas fa-book me-1"></i> Aasinet
                        <span class="badge ms-1"
                            [ngClass]="rightTab === 'aasinet' ? 'bg-white text-primary' : 'bg-secondary text-white'">
                            {{filteredAasinetEmployees?.length || 0}}
                        </span>
                    </button>
                    <button type="button" class="btn btn-sm"
                        [ngClass]="rightTab === 'inactive' ? 'btn-primary' : 'btn-outline-secondary'"
                        (click)="rightTab = 'inactive'">
                        <i class="fas fa-user-slash me-1"></i> Inactivos
                        <span class="badge ms-1"
                            [ngClass]="rightTab === 'inactive' ? 'bg-white text-primary' : 'bg-secondary text-white'">
                            {{inactiveEmployees?.length || 0}}
                        </span>
                    </button>
                </div>
                <button type="button" class="btn-close" (click)="showRightPanel = false" title="Cerrar panel lateral"></button>
            </div>

            <!-- TAB 1: CANDIDATOS APS -->
            @if(rightTab === 'aps'){
            <div>
               

                <!-- Barra de búsqueda y filtro tipo APS -->
                <div class="row g-2 mb-2">
                    <div class="col-7">
                        <div class="input-group input-group-sm">
                            <span class="input-group-text bg-light"><i class="fas fa-search text-muted"></i></span>
                            <input type="text" class="form-control" placeholder="Buscar funcionario..."
                                [(ngModel)]="txtFindAps" (input)="filterPendingAps()">
                        </div>
                    </div>
                    <div class="col-5">
                        <select class="form-select form-select-sm" [(ngModel)]="selectedApsTypeFilter"
                            (change)="filterPendingAps()">
                            <option [ngValue]="null">Todos los tipos</option>
                            @for(t of dataEmployeeType; track t.employeeType){
                            <option [value]="t.employeeType">{{t.employeeTypeName}}</option>
                            }
                        </select>
                    </div>
                </div>

                <!-- Tabla de Candidatos APS -->
                <div class="table-data">
                    <table class="table table-hover table-sm align-middle mb-0">
                        <thead class="sticky-top">
                            <tr>
                                <th style="width: 32px;" class="text-center">
                                    <input type="checkbox" class="form-check-input" [checked]="isAllApsSelected"
                                        (change)="toggleSelectAllAps()">
                                </th>
                                <th style="width: 55px;">Cód</th>
                                <th>Funcionario</th>
                                <th style="width: 140px;">Tipo a Ingresar</th>
                                <th class="text-center" style="width: 80px;">FMR</th>
                                <th class="text-center" style="width: 65px;">Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            @if(filteredPendingApsEmployees?.length === 0){
                            <tr>
                                <td colspan="6" class="text-center text-muted py-4">
                                    @if(isLoadingAps){
                                    <i class="fas fa-spinner fa-spin me-1 text-primary"></i> Consultando empleados en
                                    APS...
                                    } @else {
                                    <i class="fas fa-check-circle text-success me-1"></i> No hay registros pendientes en
                                    esta vista.
                                    }
                                </td>
                            </tr>
                            }
                            @for(emp of filteredPendingApsEmployees; track emp.code){
                            <tr [class.table-active]="emp.selected">
                                <td class="text-center">
                                    <input type="checkbox" class="form-check-input" [(ngModel)]="emp.selected"
                                        (change)="updateApsSelectionSummary()">
                                </td>
                                <td><span class="fw-bold">{{emp.code}}</span></td>
                                <td>
                                    <div class="fw-semibold text-dark d-flex align-items-center">
                                        <span>{{emp.names}} {{emp.departamentCode}} - {{emp.departamentName}} </span>
                                     </div>
                                    @if(emp.syncStatus === 'UPDATE' && emp.currentNames && emp.currentNames !==
                                    emp.names){
                                    <small class="text-danger fw-bold d-block" style="font-size: 10px;">
                                        <i class="fas fa-exclamation-triangle me-1"></i> @if(emp.detail &&
                                        emp.syncStatus === 'UPDATE'){
                                        <span class="text-danger ms-1">({{emp.detail}})</span>
                                        }
                                    </small>
                                    }
                                </td>
                                <td>
                                    <select class="form-select form-select py-0" [(ngModel)]="emp.selectedType"
                                        (change)="onApsTypeChange(emp)" style="font-size: 11px;">
                                        @for(t of dataEmployeeType; track t.employeeType){
                                        <option [value]="t.employeeType">{{t.employeeTypeName}}</option>
                                        }
                                    </select>
                                </td>
                                <td class="text-center">
                                    @if(emp.selectedType == 1 || emp.selectedType == 2){
                                    <input type="number" step="any" min="0"
                                        class="form-control form-control-sm text-center py-0 px-1"
                                        style="width: 70px; font-size: 11px; margin: 0 auto;"
                                        [(ngModel)]="emp.selectedFmr" placeholder="FMR" (change)="onApsFmrChange(emp)">
                                    } @else {
                                    <span class="text-muted">-</span>
                                    }
                                </td>
                                <td class="text-center">
                                    @if(emp.syncStatus === 'NEW'){
                                    <button type="button" class="btn btn-outline-success btn-xs"
                                        ngbTooltip="Incorporar nuevo funcionario" container="body"
                                        (click)="importSingleAps(emp)">
                                        <i class="fas fa-plus"></i>
                                    </button>
                                    } @else {
                                    <button type="button" class="btn btn-outline-primary btn-xs"
                                        ngbTooltip="Actualizar datos con APS" container="body"
                                        (click)="importSingleAps(emp)">
                                        <i class="fas fa-sync-alt"></i>
                                    </button>
                                    }
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>

                <!-- Footer de Acción en Lote para APS -->
                <div class="d-flex justify-content-between align-items-center mt-3 pt-2 border-top">
                    <small class="text-muted">
                        <strong>{{selectedApsCount}}</strong> seleccionados
                        @if(selectedNewCount > 0 && selectedUpdateCount > 0){
                        ({{selectedNewCount}} nuevos, {{selectedUpdateCount}} a actualizar)
                        }
                    </small>
                    <button type="button" class="btn btn-primary btn-sm" [disabled]="selectedApsCount === 0"
                        (click)="importSelectedAps()">
                        <i class="fas fa-download me-1"></i>
                        @if(selectedUpdateCount > 0 && selectedNewCount === 0){
                        Actualizar Seleccionados ({{selectedApsCount}})
                        } @else if(selectedNewCount > 0 && selectedUpdateCount === 0){
                        Importar Seleccionados ({{selectedApsCount}})
                        } @else {
                        Sincronizar Seleccionados ({{selectedApsCount}})
                        }
                    </button>
                </div>
            </div>
            }

            <!-- TAB 2: CATÁLOGO AASINET (DIVERSOS) -->
            @if(rightTab === 'aasinet'){
            <div>
                <!-- Barra de búsqueda Aasinet y botón de sincronizar -->
                <div class="d-flex gap-2 mb-2">
                    <div class="input-group input-group-sm flex-grow-1">
                        <span class="input-group-text bg-light"><i class="fas fa-search text-muted"></i></span>
                        <input type="text" class="form-control" placeholder="Buscar por código o nombre en Aasinet..."
                            [(ngModel)]="txtFindAasinet" (input)="filterAasinetEmployees()">
                        @if(txtFindAasinet){
                        <button class="btn btn-outline-secondary" type="button"
                            (click)="txtFindAasinet=''; filterAasinetEmployees()">
                            <i class="fas fa-times"></i>
                        </button>
                        }
                    </div>
                </div>

                <!-- Tabla de Aasinet -->
                <div class="table-data">
                    <table class="table table-hover table-sm align-middle mb-0">
                        <thead class="sticky-top">
                            <tr>
                                <th style="width: 32px;" class="text-center">
                                    <input type="checkbox" class="form-check-input" [checked]="isAllAasinetSelected"
                                        (change)="toggleSelectAllAasinet()">
                                </th>
                                <th style="width: 55px;">Cód</th>
                                <th>Funcionario</th>
                                <th style="width: 140px;">Tipo a Ingresar</th>
                                <th class="text-center" style="width: 80px;">FMR</th>
                                <th class="text-center" style="width: 60px;">Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            @if(filteredAasinetEmployees?.length === 0){
                            <tr>
                                <td colspan="6" class="text-center text-muted py-4">
                                    <i class="fas fa-info-circle text-info me-1"></i> No se encontraron funcionarios disponibles en Aasinet.
                                </td>
                            </tr>
                            }
                            @for(emp of filteredAasinetEmployees; track emp.code){
                            <tr [class.table-active]="emp.selected">
                                <td class="text-center">
                                    <input type="checkbox" class="form-check-input" [(ngModel)]="emp.selected"
                                        (change)="updateAasinetSelectionSummary()">
                                </td>
                                <td><span class="fw-bold">{{emp.code}}</span></td>
                                <td><span class="fw-semibold text-dark">{{emp.name}}</span></td>
                                <td>
                                    <select class="form-select form-select-sm py-0" [(ngModel)]="emp.selectedType"
                                        (change)="onAasinetTypeChange(emp)" style="font-size: 11px;">
                                        @for(t of dataEmployeeType; track t.employeeType){
                                        <option [value]="t.employeeType">{{t.employeeTypeName}}</option>
                                        }
                                    </select>
                                </td>
                                <td class="text-center">
                                    @if(emp.selectedType == 1 || emp.selectedType == 2){
                                    <input type="number" step="any" min="0" class="form-control form-control-sm text-center py-0 px-1"
                                        style="width: 70px; font-size: 11px; margin: 0 auto;"
                                        [(ngModel)]="emp.selectedFmr"
                                        placeholder="FMR">
                                    } @else {
                                    <span class="text-muted">-</span>
                                    }
                                </td>
                                <td class="text-center">
                                    <button type="button" class="btn btn-outline-success btn-xs"
                                        ngbTooltip="Incorporar funcionario" container="body"
                                        (click)="importSingleAasinet(emp)">
                                        <i class="fas fa-plus"></i>
                                    </button>
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>

                <!-- Footer de Acción en Lote para Aasinet -->
                <div class="d-flex justify-content-between align-items-center mt-3 pt-2 border-top">
                    <small class="text-muted">
                        <strong>{{selectedAasinetCount}}</strong> seleccionados
                    </small>
                    <button type="button" class="btn btn-primary btn-sm" [disabled]="selectedAasinetCount === 0"
                        (click)="importSelectedAasinet()">
                        <i class="fas fa-user-plus me-1"></i> Incorporar Seleccionados ({{selectedAasinetCount}})
                    </button>
                </div>
            </div>
            }

            <!-- TAB 3: EMPLEADOS INACTIVOS / EXCLUIDOS -->
            @if(rightTab === 'inactive'){
            <div>
                <!-- Barra de búsqueda Inactivos -->
                <div class="input-group input-group-sm mb-2">
                    <span class="input-group-text bg-light"><i class="fas fa-search text-muted"></i></span>
                    <input type="text" class="form-control" placeholder="Buscar en inactivos..."
                        [(ngModel)]="txtFindInactive" (input)="filterInactiveEmployees()">
                    @if(txtFindInactive){
                    <button class="btn btn-outline-secondary" type="button"
                        (click)="txtFindInactive=''; filterInactiveEmployees()">
                        <i class="fas fa-times"></i>
                    </button>
                    }
                </div>

                <!-- Tabla de Inactivos -->
                <div class="table-responsive" style="max-height: 440px; overflow-y: auto;">
                    <table class="table table-hover table-sm align-middle mb-0">
                        <thead class="sticky-top">
                            <tr>
                                <th style="width: 32px;" class="text-center">
                                    <input type="checkbox" class="form-check-input" [checked]="isAllInactiveSelected"
                                        (change)="toggleSelectAllInactive()">
                                </th>
                                <th style="width: 55px;">Cód</th>
                                <th>Funcionario</th>
                                <th>Tipo</th>
                                <th class="text-center" style="width: 70px;">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            @if(filteredInactiveEmployees?.length === 0){
                            <tr>
                                <td colspan="5" class="text-center text-muted py-4">
                                    <em>No hay empleados inactivos.</em>
                                </td>
                            </tr>
                            }
                            @for(d of filteredInactiveEmployees; track d.id){
                            <tr [class.table-active]="d.selected">
                                <td class="text-center">
                                    <input type="checkbox" class="form-check-input" [(ngModel)]="d.selected"
                                        (change)="updateInactiveSelectionSummary()">
                                </td>
                                <td><span class="fw-bold">{{d.code}}</span></td>
                                <td>
                                    <div class="fw-semibold text-muted">{{d.names}}</div>
                                    @if(d.departamentCode && d.departamentCode !== '-1' && d.departamentCode !== '0'){
                                    <small class="text-muted d-block" style="font-size: 11px;">
                                        <i class="fas fa-building me-1 opacity-50"></i>{{d.departamentCode}} - {{d.departamentName || ''}}
                                    </small>
                                    }
                                </td>
                                <td><small class="text-muted">{{d.employeeTypeName}}</small></td>
                                <td class="text-center">
                                    <div class="d-flex justify-content-center gap-1">
                                        <button type="button" class="btn btn-outline-success btn-xs"
                                            ngbTooltip="Reactivar empleado" container="body"
                                            (click)="reactivateEmployee(d)">
                                            <i class="fas fa-undo"></i>
                                        </button>
                                        <button type="button" class="btn btn-outline-danger btn-xs"
                                            ngbTooltip="Eliminar permanentemente" container="body"
                                            (click)="deleteDiverse(d)">
                                            <i class="fas fa-trash-alt"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>

                <!-- Footer de Acción en Lote para Inactivos -->
                <div class="d-flex justify-content-between align-items-center mt-3 pt-2 border-top">
                    <small class="text-muted">
                        <strong>{{selectedInactiveCount}}</strong> seleccionados
                    </small>
                    <button type="button" class="btn btn-success btn-sm" [disabled]="selectedInactiveCount === 0"
                        (click)="reactivateSelectedInactive()">
                        <i class="fas fa-user-check me-1"></i> Reactivar Seleccionados ({{selectedInactiveCount}})
                    </button>
                </div>
            </div>
            }
        </div>
    </div>
    }
</div>

<!-- Modal Formulario Diverso (Edición/Nuevo Manual) -->
<ng-template #modal_diverse let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title">{{modalHeaderDiverse}}</h4>
        <button type="button" class="btn-close" aria-label="Close"
            (click)="d('Cross click');isNewDiverse=false;diverseFinded=false"></button>
    </div>
    <div class="modal-body">
        <div class="row">
            <form [formGroup]="formDiverse">
                <div class="form-group row">
                    <label class="col-md-4 col-form-label">Diverso</label>
                    <div class="col-md-8">
                        @if(modalHeaderDiverse==='Nuevo Diverso'){
                        <ng-select #ngSelectAssinet [items]="dataNgSelectAssinet" [selectableGroup]="true"
                            [closeOnSelect]="true" [dropdownPosition]="'bottom'" [multiple]="false" bindValue="diverse"
                            bindLabel="nameDiverse" [selectableGroupAsModel]="false"
                            placeholder="Buscar por diverso, nombre..." formControlName="code" name="code"
                            (close)="onCloseNgSelectAssinet()" tabindex="1">
                        </ng-select>
                        } @else {
                        <div class="input-group">
                            <input type="text" class="form-control" [value]="diverseCopy" readonly disabled>
                            <button type="button" class="btn btn-outline-primary btn-sm" (click)="editDiverse()">
                                <i class="fa-solid fa-pen-to-square"></i>
                            </button>
                        </div>
                        }
                        @if(formDiverse.get('code')?.errors?.required && formDiverse.get('code').touched){
                        <div><small class="text-danger">Diverso es requerido.</small></div>
                        }
                    </div>
                </div>&nbsp;
                <div class="form-group row">
                    <label class="col-md-4 col-form-label">Nombre Funcionario</label>
                    <div class="col-md-8">
                        <input type="text" #nameInput
                            [class.is-invalid]="formDiverse.get('names').invalid && formDiverse.get('names').touched"
                            formControlName="names" name="names" class="form-control" tabindex="2" />
                        @if(formDiverse.get('names')?.errors?.required && formDiverse.get('names').touched){
                        <div><small class="text-danger">Nombre de funcionario es requerido.</small></div>
                        }
                    </div>
                </div>&nbsp;
                <div class="form-group row">
                    <label class="col-md-4 col-form-label">Tipo Diverso</label>
                    <div class="col-md-8">
                        <select [class.is-invalid]="formDiverse.get('type').invalid && formDiverse.get('type').touched"
                            class="form-control form-select" formControlName="type" name="type" tabindex="3">
                            <option disabled selected>Seleccione un tipo de diverso</option>
                            @for(e of dataEmployeeType; track e.employeeType){
                            <option [value]="e.employeeType">{{e.employeeTypeName}}</option>
                            }
                        </select>
                        @if(formDiverse.get('type')?.errors?.required && formDiverse.get('type').touched){
                        <div><small class="text-danger">Tipo de diverso es requerido.</small></div>
                        }
                    </div>
                </div>&nbsp;
                @if(formDiverse.get('type')?.value===1 || formDiverse.get('type')?.value===2){
                <div class="form-group row">
                    <label class="col-md-4 col-form-label">FMR Funcionario</label>
                    <div class="col-md-8">
                        <input type="text"
                            [class.is-invalid]="formDiverse.get('employeeFmr').invalid && formDiverse.get('employeeFmr').touched"
                            formControlName="employeeFmr" name="employeeFmr" class="form-control" tabindex="4" />
                    </div>
                </div>&nbsp;
                }
            </form>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-sm"
            (click)="d('Cross click');isNewDiverse=false;diverseFinded=false">
            <i class="fas fa-times"></i>&nbsp; Cerrar
        </button>
        @if(modalHeaderDiverse==='Nuevo Diverso'){
        <button type="button" class="btn btn-primary btn-sm"
            (click)="submitDiverseNew();isNewDiverse=false;diverseFinded=false"
            [disabled]="formDiverse.pristine && !formDiverse.valid || !formDiverse.valid" tabindex="4">
            <i class="fas fa-save"></i>&nbsp;Guardar
        </button>
        }
        @if(modalHeaderDiverse==='Modificar Diverso'){
        <button type="button" class="btn btn-primary btn-sm" [disabled]="formDiverse.pristine || !formDiverse.valid"
            (click)="submitDiverseUpdate();isNewDiverse=false;diverseFinded=false" tabindex="4">
            <i class="fas fa-save"></i>&nbsp;Guardar
        </button>
        }
    </div>
</ng-template>